<template>
  <p></p>
  <div style="text-align:left" class="container font-custom text-white">
    <h1>
      <color_yellowgreen>Senden Sie uns eine Nachricht ...</color_yellowgreen>
      <color_orange>(Feature kommt bald)</color_orange>
    </h1>
    <!-- <form action="https://www.formbackend.com/f/{your-identifier}" method="POST"> -->
    
    <form>
      <div class="row mb-3">
        <label for="contact_name" class="col-sm-2 col-form-label">Name</label>
        <div class="col-sm-10">
          <input type="text" class="form-control form-control-sm" id="contact_name" placeholder="Mustermann" required disabled>
        </div>
      </div>
      <div class="row mb-3">
        <label for="contact_email" class="col-sm-2 col-form-label">Email</label>
        <div class="col-sm-10">
          <input type="email" class="form-control" id="contact_email" placeholder="max@mustermann.de" required disabled>
        </div>
      </div>
      <div class="row mb-3">
        <label for="contact_text" class="col-sm-2 col-form-label">Nachricht</label>
        <div class="col-sm-10">
          <textarea class="form-control" id="contact_text" rows="4" placeholder="Ihre Nachricht" required disabled></textarea>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-sm-2"></div>
        <div class="col-sm-10">
          <button class="btn btn-primary" type="submit" disabled>Nachricht versenden</button>
        </div>
      </div>
    </form>

</div>
</template>

<style>
  .form-fields {
    margin-bottom: 1rem;
  }
  label {
    display: block;
    margin-bottom: 4px;
    font-weight: bold;
    font-size: 0.9rem;
    padding-left: 10px;
  }
  input[type="text"], input[type="email"], textarea {
    border: 1px solid #ccc;
    font-size: 1rem;
    padding: 6px 10px;
    border-radius: 4px;
    margin-left: 20px;
  }
  body { display: block }
  button[type="submit"] {
    background-color: rgb(67 56 202);
    color: white;
    font-size: 0.8rem;
    border: none;
    border-radius: 4px;
    padding: 8px 12px;
    font-weight: 500;
    margin-left: 20px;
  }
</style>